<template>
    <div>
        <v-navigation-drawer v-model="drawer" fixed permanent expand-on-hover>
            <v-list>
                <v-list-item class="px-2">
                    <v-list-item-avatar>
                        <v-img src="@/assets/tp-logo.png"></v-img>
                    </v-list-item-avatar>
                </v-list-item>

                <v-list-item>
                    <v-list-item-content>
                        <v-list-item-title class="title">{{ firstName }} {{ surname }}</v-list-item-title>
                        <v-list-item-subtitle>{{ email }}</v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item-group v-for="item in items" 
                                   :key="item.title"
                                   color="primary">
                    <v-list-item v-if="!item.items" :to="item.path" dense @click="item.path == '/logout' ? logout() : null">
                        <v-list-item-icon>
                            <v-icon>{{ item.icon }}</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                    </v-list-item>

                    <v-list-group v-else no-action>
                        <template v-slot:activator>
                             <v-list-item-icon>
                                <v-icon>{{ item.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title>{{ item.title }}</v-list-item-title>
                            </v-list-item-content>
                        </template>

                        <v-list-item v-for="element in item.items"
                                     :key="element.title"
                                     :to="element.path"
                                     dense
                                     class="pl-8">
                            <v-list-item-icon>
                                <v-icon>{{ element.icon }}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title>{{ element.title }}</v-list-item-title>
                            
                        </v-list-item>
                    </v-list-group>
                </v-list-item-group>
            </v-list>

            <v-divider></v-divider>

            <v-list dense>
                <v-list-item class="state-switch-container">
                    <div class="state-switch">
                        <v-switch v-model="stateSwitch"
                                    :label="`State: ${state}`"
                                    dense
                                    @change="switchPress"
                                    :disabled="displaySwitch"
                        ></v-switch>
                    </div>
                    <div id="state-mini" class="text-center" :class="state == 'LIVE' ? 'green--text text--darken-1' : 'red--text text--darken-1'">
                        <v-btn
                            :color="state == 'LIVE' ? '#42A5F5' : '#E57373'"
                            fab
                            x-small
                            dark
                            class="elevation-0"
                        >
                            {{ state }}
                        </v-btn>
                    </div>
                </v-list-item>
            </v-list>
        </v-navigation-drawer>
    </div>
</template>

<script>
    export default {
        props: {
            showPos: Boolean
        },
        data: () => ({
            items: [{ title: 'Dashboard', icon: 'mdi-home', path: '/' },
                    { title: 'Transactions', icon: 'mdi-swap-horizontal', path: '/transactions' },
                    // { title: 'Transactions MyST', icon: 'mdi-swap-horizontal', path: '/transactions-my-st' },
                    { title: 'Chargebacks Defender', icon: 'mdi-shield-check', path: '/chargebacks-defender' },
                    { title: 'Risk Alerts', icon: 'mdi-alert-circle', path: '/risk-alerts' },
                    { title: 'Reports', icon: 'mdi-chart-multiple', path: '/reports' },
                    { title: 'Tools', icon: 'mdi-tools', path: '', items: [
                        { title: 'eTerminal', icon: 'mdi-tablet', path: '/eterminal' },
                        { title: 'Pay By Link', icon: 'mdi-cellphone-link', path: '/pay-by-link' }]
                    },
                    { title: 'Users', icon: 'mdi-account-cog', path: '', items: [
                        { title: 'Add User', icon: 'mdi-account-plus', path: '/add-user' },
                        { title: 'Edit User', icon: 'mdi-account-edit', path: '/edit-user' }
                        ]
                    },
                    // { title: 'Credentials', icon: 'mdi-key', path: '/credentials' },
                    { title: 'Logout', icon: 'mdi-logout', path: '/logout' }],
            drawer: true,
            stateSwitch: true,
            firstName: JSON.parse(localStorage.getItem('user')).first_name,
            surname: JSON.parse(localStorage.getItem('user')).surname,
            email: JSON.parse(localStorage.getItem('user')).email
        }),
        beforeMount() {
            // if(this.$store.state.user.id == 241) {
            //     this.items.splice(2, 0, { title: 'Chargebacks', icon: 'mdi-shield-check', path: '/chargebacks-defender' });
            // }
        },
        created() {
            if(this.$store.state.user.user_role.id > 3 && this.$store.state.user.merchant_access === null && this.$store.state.user.merchant_access_test !== null) {
                this.stateSwitch = false;
                this.$store.dispatch('switchPress', false);
            }
        },
        computed: {
            state() {
                return this.stateSwitch ? 'LIVE' : 'TEST';
            },
            displaySwitch() {
                if(this.$store.state.user.user_role.id > 3) {
                    if(this.$store.state.user.merchant_access === null || this.$store.state.user.merchant_access_test === null) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return false;
                }
            }
        },

        mounted: function() {
            if (this.showPos) {
                var posInsertIndex = this.items.length - 1;
                this.items.forEach((e, i) => {
                    if (e.title.includes("Transactions")) {
                        posInsertIndex = i + 1;
                    }
                });
                this.items.splice(posInsertIndex, 0, { title: 'Transactions NI POS', icon: 'mdi-swap-horizontal', path: '/transactions-ni-pos' });
            }
        },

        methods:{
            logout() {
                this.$store.dispatch('logout');
            },
            switchPress(e) {
                this.$store.dispatch('switchPress', e);
            }
        }
    }
</script>

<style>
 
</style>